import _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Table } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import Localization from '../../config/localization';

import * as BeneficiarySearchAction from '../../actions/BeneficiarySearch';

import * as PartnersApi from '../../api/partners';

import ArrowRightSvg from '../../components/Svg/arrowRight';

import Notifications from '../../lib/notifications';
import { GetName, ToNumber, ToString } from '../../lib/utils';

import BackButton from '../../components/BackButton';
import Client from '../../components/Client';
import Loader from '../../components/Loader';

import './AssociationAids.scss';
import { generatePath } from 'react-router';
import { Routes } from '../../constants/routes';

type IProps = AssociationAids.IProps & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class AssociationAids extends React.Component<IProps, AssociationAids.IState> {
  state: AssociationAids.IState = {
    partner: undefined,
    utilityType: (this.props.BeneficiarySearch && this.props.BeneficiarySearch.utilityType) || '',

    loading: false,
    loadingMessage: ''
  };

  componentDidMount() {
    return this._getPartner();
  }

  renderAssociationRow() {
    if (!this.state.partner) {
      return undefined;
    }

    return this.state.partner.consumptionPoints.map(consumptionPoint => {
      return consumptionPoint.aids.map(aid => {
        return (
          <tr className="c-pointer-no-color" id={ToString(aid.aidId)} key={aid.aidId}
              onClick={this._goToAddBeneficiary}>
            <td>
              <h5 className="eon-title eon-middle-grey strong w-max-content c-text"
                  onClickCapture={this._stopPropagation}>
                {GetName({ firstName: aid.firstName, lastName: aid.lastName })}
              </h5>
            </td>
            <td>
              <p className="eon-title eon-middle-grey w-max-content c-text" onClickCapture={this._stopPropagation}>
                {aid.personalIdentificationNumber}
              </p>
            </td>
            <td className="text-right pr-4">
              <ArrowRightSvg className="m-0 c-pointer align-center" />
            </td>
          </tr>
        );
      });
    });
  }

  renderTable() {
    if (!this._hasAids()) {
      return <p
        className="eon-title eon-middle-grey strong my-5 mx-4 text-nowrap">{Localization.associationAidsNotExist}</p>;
    }

    return (
      <Table className="my-5 text-left bg-eon-white" hover>
        <thead>
        <tr>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red">{Localization.beneficiarySearchName}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red mt-1">{Localization.beneficiarySearchCNP}</p>
          </th>
          <th className="align-top" scope="col" />
        </tr>
        </thead>
        <tbody>{this.renderAssociationRow()}</tbody>
      </Table>
    );
  }

  render() {
    return (
      <Container className="associations-aids px-5 py-4 my-4">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        {this.state.partner && <Client partner={this.state.partner} extraClassName="client-card mt-4" />}

        {this.renderTable()}

        <div className="mx-4">
          <button className="eon-button bg-eon-red eon-white" onClick={this._goToAddBeneficiary}>
            <span className="px-3">{Localization.associationAidsAddButton}</span>
          </button>
        </div>
      </Container>
    );
  }

  _getPartner = async () => {
    try {
      await this.setState({ loading: true });

      const response = await PartnersApi.GetPartner({
        search: this.props.match.params.consumptionPoint,
        utilityType: this.state.utilityType
      });

      const partner = response.data && response.data[0];

      if (!partner) {
        return undefined;
      }

      const consumptionPoints = (partner.consumptionPoints && partner.consumptionPoints.length && partner.consumptionPoints) || [];

      if (consumptionPoints && consumptionPoints.length && consumptionPoints[0].aids && consumptionPoints[0].aids.length) {
        consumptionPoints[0].aids = _.uniqBy(consumptionPoints[0].aids, 'personalIdentificationNumber');
      }

      partner.consumptionPoints = [...consumptionPoints];

      await this.setState({ partner });

      return this.setState({ loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _stopPropagation = (event: React.MouseEvent<HTMLElement>) => {
    if (!event || !event.stopPropagation) {
      return undefined;
    }
    return event.stopPropagation();
  };

  _goToAddBeneficiary = async (event: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLTableRowElement>) => {
    event.preventDefault();

    const target = event.currentTarget || event.target || {};

    const aidId = ToNumber(target.id);
let setAidInfo = false;

    if (this.state.partner && this.state.partner.consumptionPoints && this.state.partner.consumptionPoints.length) {
      this.state.partner.consumptionPoints.find(
        consumptionPoint =>
          consumptionPoint &&
          !!consumptionPoint.aids.find(aid => {
            if (aid && aid.aidId === aidId) {
              this.props.SetAidInfo(aid.aidId, aid.personalIdentificationNumber);
              setAidInfo = true;
              return true;
            }
            return false;
          })
      );
    }

    if(!setAidInfo) {
      this.props.SetAidInfo();
    }

    return this.props.history.push(generatePath(Routes.Aid, { ...this.props.match.params }));
  };

  _hasAids = () => {
    return !!(
      this.state.partner &&
      this.state.partner.consumptionPoints &&
      this.state.partner.consumptionPoints.length &&
      this.state.partner.consumptionPoints[0] &&
      this.state.partner.consumptionPoints[0].aids &&
      this.state.partner.consumptionPoints[0].aids.length
    );
  };
}

const mapStateToProps = (state: General.Store) => ({ BeneficiarySearch: state.BeneficiarySearch });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({ ...BeneficiarySearchAction }, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssociationAids);
